export const messages = {
  en: {
    payFeeAuditManage: {
      searchTitle: 'Search Conditions',
      tableTitle: 'Payment Audit',
      selectPayObj: 'Select Payment Object',
      selectStatus: 'Select Status',
      inputPlateNumber: 'Enter License Plate Number',
      inputRoomInfo: 'Enter Building-Unit-Room',
      house: 'House',
      feeItem: 'Fee Item',
      payCycle: 'Payment Cycle',
      month: 'month(s)',
      startTime: 'Start Time',
      endTime: 'End Time',
      receivableAmount: 'Receivable Amount(Yuan)',
      receivedAmount: 'Received Amount(Yuan)',
      operator: 'Operator',
      payTime: 'Payment Time',
      auditStatus: 'Audit Status',
      auditRemark: 'Audit Remark',
      payRemark: 'Payment Remark',
      pendingReview: 'Pending Review',
      approved: 'Approved',
      rejected: 'Rejected',
      batchAudit: 'Batch Audit',
      auditFee: 'Audit Fee',
      refund: 'Refund',
      auditTip: 'Payment audit will not affect payment accounting, used by finance to verify payment correctness',
      fetchError: 'Failed to fetch payment audit data',
      selectFeeTip: 'Please select at least one fee'
    },
    audit: {
      auditInfo: 'Audit Information',
      auditStatus: 'Audit Status',
      selectAudit: 'Select Audit',
      agree: 'Agree',
      reject: 'Reject',
      reason: 'Reason',
      inputReason: 'Required, please enter reason',
      stateRequired: 'Audit status is required',
      reasonRequired: 'Reason is required',
      reasonMaxLength: 'Reason cannot exceed 200 characters'
    },
    returnPayFee: {
      refundTitle: 'Fill Refund Reason',
      fee: 'Payment',
      cycle: 'Cycle',
      month: 'month',
      receivableAmount: 'Receivable Amount',
      receivedAmount: 'Received Amount',
      payTime: 'Payment Time',
      refundReason: 'Refund Reason',
      inputReason: 'Enter refund reason',
      submitRefund: 'Submit Refund Application',
      reasonRequired: 'Refund reason is required',
      reasonLength: 'Refund reason must be between 1-200 characters'
    }
  },
  zh: {
    payFeeAuditManage: {
      searchTitle: '查询条件',
      tableTitle: '缴费审核',
      selectPayObj: '请选择付费对象',
      selectStatus: '请选择状态',
      inputPlateNumber: '请填写车牌号',
      inputRoomInfo: '请填写房屋 楼栋-单元-室',
      house: '房屋',
      feeItem: '费用项目',
      payCycle: '付费周期',
      month: '个月',
      startTime: '缴费起始时间',
      endTime: '缴费结束时间',
      receivableAmount: '应付金额(单位:元)',
      receivedAmount: '实付金额(单位:元)',
      operator: '操作员工',
      payTime: '缴费时间',
      auditStatus: '审核状态',
      auditRemark: '审核说明',
      payRemark: '缴费备注',
      pendingReview: '待审核',
      approved: '审核通过',
      rejected: '审核未通过',
      batchAudit: '批量审核',
      auditFee: '审核费用',
      refund: '退费',
      auditTip: '缴费审核不会影响缴费入账，财务用来核对缴费是否正确',
      fetchError: '获取缴费审核数据失败',
      selectFeeTip: '请选择费用'
    },
    audit: {
      auditInfo: '审核信息',
      auditStatus: '审核状态',
      selectAudit: '请审核',
      agree: '同意',
      reject: '拒绝',
      reason: '原因',
      inputReason: '必填，请填写原因',
      stateRequired: '审核状态不能为空',
      reasonRequired: '原因内容不能为空',
      reasonMaxLength: '原因内容不能超过200'
    },
    returnPayFee: {
      refundTitle: '填写退费原因',
      fee: '缴费',
      cycle: '周期',
      month: '月',
      receivableAmount: '应收金额',
      receivedAmount: '实收金额',
      payTime: '缴费时间',
      refundReason: '退费原因',
      inputReason: '填写退费原因',
      submitRefund: '提交退费申请',
      reasonRequired: '退费原因不能为空',
      reasonLength: '退费原因必须为1-200个字符'
    }
  }
}